// Hardcoded sample report for development.
// Replaced by real GitHub API fetch in step 5.

export const SAMPLE_REPORT = {
  type: 'correspond-report',
  version: '1',
  id: '20260223T143022-myapp-auth-middleware',
  project: 'myapp',
  title: 'Auth middleware complete — token strategy decision needed',
  created: '2026-02-23T14:30:22Z',
  sections: [
    {
      type: 'text',
      id: 's1',
      title: 'What I did',
      content:
        'Implemented JWT validation middleware across three routes: profile, settings, and data. ' +
        'Added token expiry checking and a custom 401 response shape. ' +
        'All existing tests pass, and I added twelve new tests covering expiry, invalid signature, and missing token cases.',
      pause: 10,
    },
    {
      type: 'text',
      id: 's2',
      title: 'What I found',
      content:
        'The session table has a bug: tokens are not being invalidated on logout. ' +
        'This is separate from the middleware work but should be fixed before releasing to production. ' +
        "I can tackle it now or log it as a follow-up — your call.",
      pause: 12,
    },
    {
      type: 'question',
      id: 'q1',
      kind: 'multiple_choice',
      prompt: 'Should I implement refresh token rotation?',
      options: [
        { id: 'a', text: 'Yes, implement it now' },
        { id: 'b', text: 'No, short-lived access tokens are fine for now' },
        { id: 'c', text: 'Show me the security tradeoffs first' },
      ],
      required: true,
    },
    {
      type: 'text',
      id: 's3',
      title: "What's next",
      content:
        "After your decision on refresh tokens, I'll move to the password reset flow. " +
        'That requires an email provider integration. ' +
        'I was planning to use Resend but can switch to SendGrid if you have a preference.',
      pause: 10,
    },
    {
      type: 'question',
      id: 'q2',
      kind: 'open_ended',
      prompt: 'Any concerns or preferences on the email provider?',
      required: false,
      pause: 12,
    },
  ],
}
